import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import axios from 'axios';
import Vue from 'vue';

if (process.env.NODE_ENV === 'dev') {
  window.axios = axios;
}

function toErrorRouteHandler(error) {
  Vue.prototype.$router.replace('/error/网络出错');
}

var defaultOption = {
  errorHandler: toErrorRouteHandler
};

function pickParamsToConfig(config, keys) {
  if (!config.params) {
    config.params = {};
  }

  keys.forEach(function (key) {
    config[key] = config.params[key];
    delete config.params[key];
  });
}

function createAjax() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOption,
      _ref$errorHandler = _ref.errorHandler,
      errorHandler = _ref$errorHandler === void 0 ? toErrorRouteHandler : _ref$errorHandler,
      rest = _objectWithoutProperties(_ref, ["errorHandler"]);

  var service = axios.create(_objectSpread({
    timeout: 10000,
    withCredentials: false
  }, rest));
  var ShowLoadingDelayTime = 1000; // 添加请求拦截器

  service.interceptors.request.use(function (config) {
    pickParamsToConfig(config, ['noLoading', 'rejectToErrorPage']);

    if (!config['noLoading']) {
      config['requestId'] = setTimeout(function () {
        Vue.$loading.show();
      }, ShowLoadingDelayTime);
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  }); // 添加响应拦截器

  service.interceptors.response.use(function (response) {
    // 对响应数据做些事
    if (response.config && response.config['requestId']) {
      clearTimeout(response.config['requestId']);
    }

    Vue.$loading.hide();
    return response;
  }, function (error) {
    // 请求错误时做些事
    if (error.config && error.config['requestId']) {
      clearTimeout(error.config['requestId']);
    }

    Vue.$loading.hide(); // console.log('error config', error.config);

    if (error.config && error.config.rejectToErrorPage) {} else {
      errorHandler(error);
    }

    return Promise.reject(error);
  });
  return service;
}

export default createAjax;